// Lenis smooth scrolling, as on the homepage (Lenis itself is loaded from the CDN by each page).
// Same-page anchor links (#how, /docs#fees while on /docs) glide to their target, 90 px below the nav.
let lenis = null;

export function initSmooth() {
  const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (window.Lenis && !reduce) {
    try {
      lenis = new window.Lenis({ lerp: 0.1, smoothWheel: true });
      const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
      window.__lenis = lenis;
    } catch (e) {
      lenis = null;
    }
  }
  document.addEventListener("click", (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest("a[href]");
    if (!a || a.target === "_blank") return;
    const raw = a.getAttribute("href");
    let url;
    try { url = new URL(raw, location.href); } catch { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const id = url.hash;
    const target = id === "#top" ? 0 : document.getElementById(decodeURIComponent(id.slice(1)));
    if (target === null) return;
    e.preventDefault();
    scrollToTarget(target, id === "#top" ? 0 : -90);
    if (id !== "#top") history.replaceState(null, "", id);
  });
}

export function scrollToTarget(target, offset = -90) {
  if (lenis) lenis.scrollTo(target, { offset });
  else if (target === 0) window.scrollTo({ top: 0, behavior: "smooth" });
  else if (target && target.getBoundingClientRect) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY + offset, behavior: "smooth" });
}
